import React from "react";
import { Box, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronCircleDown,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronCircleUp,
} from "@fortawesome/sharp-solid-svg-icons";

library.add(faChevronCircleDown);
library.add(faChevronCircleUp);
library.add(faChevronCircleLeft);
library.add(faChevronCircleRight);

interface ChevronCircleProps {
  color: "success" | "error";
  direction: "up" | "down" | "left" | "right";
  marginLeft?: string;
  marginRight?: string;
}

export const ChevronCircleSolid = ({
  color,
  direction,
  marginLeft,
  marginRight,
}: ChevronCircleProps) => {
  let colorSelection;
  const theme = useTheme();

  if (color == "success") {
    colorSelection = theme?.palette?.success.main;
  } else {
    colorSelection = theme?.palette?.error.main;
  }
  if (direction == "down")
    return (
      <Box
        component={"span"}
        sx={{ marginLeft: marginLeft ?? "0px", marginRight: marginRight ?? "0px" }}
      >
        <FontAwesomeIcon icon={faChevronCircleDown} style={{ color: colorSelection }} />
      </Box>
    );

  if (direction == "up")
    return (
      <Box
        component={"span"}
        sx={{ marginLeft: marginLeft ?? "0px", marginRight: marginRight ?? "0px" }}
      >
        <FontAwesomeIcon icon={faChevronCircleUp} style={{ color: colorSelection }} />
      </Box>
    );

  if (direction == "left")
    return (
      <Box
        component={"span"}
        sx={{ marginLeft: marginLeft ?? "0px", marginRight: marginRight ?? "0px" }}
      >
        return <FontAwesomeIcon icon={faChevronCircleLeft} style={{ color: colorSelection }} />;
      </Box>
    );

  if (direction == "right")
    return (
      <Box
        component={"span"}
        sx={{ marginLeft: marginLeft ?? "0px", marginRight: marginRight ?? "0px" }}
      >
        return <FontAwesomeIcon icon={faChevronCircleRight} style={{ color: colorSelection }} />;
      </Box>
    );
};
